// @ts-nocheck
import { httpClient } from '../../../core/network';

class CompanyService {
  static fetchCompanies(
    { onlyActive = true, withContracts = true } = {},
    { orderBy = 'name', sortOrder = 'asc' } = {},
    page = 1,
    size = 20
  ) {
    const apiUrl = '/companies';
    return httpClient.get(apiUrl, {
      params: {
        onlyactive: onlyActive,
        withcontracts: withContracts,
        orderby: orderBy,
        sortorder: sortOrder,
        page,
        size,
      },
    });
  }

  static fetchCompany(companyId) {
    const apiUrl = `/companies/${companyId}`;
    return httpClient.get(apiUrl);
  }

  static createCompany(companyData) {
    const apiUrl = '/companies';
    return httpClient.post(apiUrl, companyData);
  }

  static updateCompany(companyData) {
    const apiUrl = `/companies/${companyData.id}`;
    return httpClient.put(apiUrl, companyData);
  }

  static async searchCompanies(filterParams) {
    const apiUrl = `/companies`;
    try {
      return httpClient.get(apiUrl, {
        params: {
          onlyactive: filterParams.onlyActive,
          withcontracts: filterParams.withContracts,
          searchterm: filterParams.searchTerm,
        },
      });
    } catch (all) {
      return Promise.resolve([]);
    }
  }
}

export default CompanyService;
